var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal_size notice_size" }, [
    _c(
      "a",
      {
        staticClass: "ui_close",
        attrs: { href: "javascript:", type: "button" },
        on: { click: _vm.closePopup }
      },
      [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
    ),
    _vm._v(" "),
    _c("dl", { staticClass: "modal_content" }, [
      _c("dt", { staticClass: "notice ellipsis" }, [
        _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.NOTICE.POPUP")))])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("dl", { staticClass: "notice_view" }, [
          _c("dt", [_vm._v(_vm._s(_vm.getNoticeTitle))]),
          _vm._v(" "),
          _c("dd", { domProps: { innerHTML: _vm._s(_vm.view.content) } })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "attachment_view" },
          [
            _vm.fileList.length > 0
              ? _c("innorix-download", {
                  attrs: {
                    id: _vm.seq,
                    name: _vm.seq,
                    uploadId: _vm.seq,
                    serviceType: "common",
                    attachList: _vm.fileList,
                    seq: _vm.seq
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.fileList.length > 0
              ? _c("dl", { staticClass: "attachment_link" }, [
                  _c("dt", [
                    _c(
                      "a",
                      {
                        staticClass: "txt_link",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.toggleLink($event)
                          }
                        }
                      },
                      [_vm._v("Having trouble downloading?")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "ul",
                      _vm._l(_vm.fileList, function(file) {
                        return _c(
                          "li",
                          { key: file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "txt_link",
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.getDownloadUrl(
                                      file.ENC_ATTCH_FILE_SEQ,
                                      file.ENC_TOKEN
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "ico_attach" }),
                                _vm._v(
                                  " " +
                                    _vm._s(file.FILE_NM) +
                                    "\n                                "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.mode === "alert"
          ? _c("div", { staticClass: "today_wrap" }, [
              _c("label", { staticClass: "checkbox-wrap" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.doNotDisplayToday,
                      expression: "doNotDisplayToday"
                    }
                  ],
                  staticClass: "notice_chk",
                  attrs: { type: "checkbox", name: "notice_chk", value: "" },
                  domProps: {
                    checked: Array.isArray(_vm.doNotDisplayToday)
                      ? _vm._i(_vm.doNotDisplayToday, "") > -1
                      : _vm.doNotDisplayToday
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.doNotDisplayToday,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.doNotDisplayToday = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.doNotDisplayToday = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.doNotDisplayToday = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", { staticClass: "check-icon" }),
                _vm._v(" "),
                _c("em", [_vm._v(_vm._s(_vm.$t("LABEL.NOTICE.DONTSHOWTODAY")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "txt_link",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.closePopup()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.ETC.083")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550fbd00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550fbd00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/other/NoticeViewPopup.vue
// module id = HDeL
// module chunks = 0